import {
	LOADING_GRAPH,
	GRAPH_LOADED,
	SET_AXIS_VALUES
} from '../redux/graph-actions';

export default function graph(
	state = {
		xData: [],
		yData: [],
		zData: [],
		loading: false,
	},
	action) {
		
	switch(action.type) {
		case LOADING_GRAPH:
			return Object.assign({}, state, {
				loading: true
			});
		case GRAPH_LOADED:
			return Object.assign({}, state, {
				loading: false
			});
		case SET_AXIS_VALUES:
			return Object.assign({}, state, {
				xData: action.axis.xFile.values,
				xMax: action.axis.xFile.max,
				xMin: action.axis.xFile.min,
				xLabel: action.axis.xFile.label,
				yData: action.axis.yFile.values,
				yMax: action.axis.yFile.max,
				yMin: action.axis.yFile.min,
				yLabel: action.axis.yFile.label,
				zData: action.axis.zFile.values,
				zMax: action.axis.zFile.max,
				zMin: action.axis.zFile.min,
				zLabel: action.axis.zFile.label,
			});
		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/redux/graph-reducer.js